/* assets/viki-plp.js — Logica filtri VIKI PLP */
(function () {
  'use strict';

  const pills  = document.querySelectorAll('.viki-filter-pill');
  const cards  = document.querySelectorAll('.viki-product-card');

  if (!pills.length || !cards.length) return;

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      const filter = pill.dataset.filter;

      /* Aggiorna stato attivo */
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');

      /* Mostra/nascondi card in base ai tag */
      cards.forEach(function (card) {
        if (filter === 'all') {
          card.removeAttribute('hidden');
          return;
        }

        const tags = (card.dataset.tags || '').split(',').map(function (t) {
          return t.trim();
        });

        if (tags.includes(filter)) {
          card.removeAttribute('hidden');
        } else {
          card.setAttribute('hidden', '');
        }
      });
    });
  });
})();
